const fingerprint = process.env.VERSION

function staticMedia(relativePath) {
  if (!relativePath) {
    throw new Error(
      `relative path should be specified, got ${typeof relativePath}`
    )
  }

  return `https://localhost.media.livenationinternational.com/assets${relativePath}?v=${fingerprint}`
}

function dynamicMedia(relativePath) {
  if (!relativePath) {
    throw new Error(
      `relative path should be specified, got ${typeof relativePath}`
    )
  }

  return `https://localhost.media.livenationinternational.com/lincsmedia${relativePath}`
}

export default {
  staticMedia,
  dynamicMedia,
}
